<template>
  <div id="app">
    <div id="logo_wrap" class="logo-wrapper">
      <img src="@/assets/images/newui/logo_4x.png" alt="">
    </div>
	  <router-view/>
  </div>
</template>
<script >
	export default {
		name: 'App',
		components: {

		},
		data(){
			return {
                currentComp : ''
            }
		},
        mounted(){
            this.currentComp  = this.$route.name;
            if (this.currentComp != 'Landing') {
                document.getElementById('app').classList.add('container')
                document.getElementById('app').classList.add('main-wrapper')
                document.getElementById('logo_wrap').classList.remove('hide')
            }else {
                document.getElementById('logo_wrap').classList.add('hide')
            }
            // debugger;
        }
	}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style media="screen" lang="scss">
/* over riding original css as per new requirement */
.text-capitalize{
    text-transform: capitalize;
}
body{
    background: #fff;
}
.main-wrapper{
    background: #fff;
    min-height: 100vh;
    padding: 10vh 0;
    text-align: center;
}
.logo-wrapper{
    width: 240px;
    margin: 0 auto;
    img{
        max-width: 100%;
    }
    &.hide{
        display: none;
    }
}
.onboarding-wrapper{
    .email-img-wrap{
        width: 240px;
        margin: 0 auto;
        img{
            max-width: 100%;
        }
    }
    .ob-leftcol{
        min-height: 80vh;
        .logo-punchline{
            padding-top: 10px;
        }
    }
    .ob-rightcol{

        .title-text{
            font-size: 20px;
            color: #6b6e70;
        }
        color: #69625F;

        h1{
            font-size: 28px;
            margin-top: 10px;
            margin-bottom: 15px;
            color: #000;
        }

        .primary-heading{
          font-size: 24px;
          margin-top: 10px;
          margin-bottom: 10px;
          color: #211e1e;
          font-weight: bold;
        }
        .secondary-heading{
          font-size: 19px;
          font-family: 'HelveticaNeueLTStd-Lt';
          max-width: 500px;
          margin: 0 auto;
          line-height: 1.25;
          color: #6b6e70;
          &.w600{
              max-width: 600px;
          }
        }
        .step-wrapper{
            width: 350px;
            max-width: 350px;
            font-size: 13px;
            margin: 0 auto;
            margin-top: 10px;
            display: inline-block;
            .stepCount{
                float: right;
            }
            .navigation-btn{
                float: left;
                cursor: pointer;
            }
        }
        .ob-button{
            font-family: 'HelveticaNeueLTStd-LtCn';
            background-color: #7E3E98;
            border: solid 1px #595159;
            outline: none;
            text-align:center;
            width: 350px;
            height: 40px;
            font-size: 17px;
            &.link-button{
                background: transparent;
                color: #495057;
                border: none;
                text-decoration: underline;
                &:hover{
                    background: transparent;
                    color: #495057;
                    border: none;
                    text-decoration: underline;
                }
            }
            &:hover{
                background-color: #7E3E98;
                border: solid 1px #595159;
            }
        }
        .ob-btn-wrapper{
            border: none;
            width: 100%;
        }
        .region-info-text{
          font-size: 15px;
          color: #211e1e;
          max-width: 500px;
          margin: 0 auto;
          font-family: 'HelveticaNeueLTStd-Lt';
        }
        .state-agent{
            max-width: 350px;
            display: inline-block;
            margin: 0 auto;
            &.w100Per{
                max-width: 100%;
                width: 100%;
            }
            &.w800{
                max-width: 800px;
                width: 100%;
            }
            .sa-checkbox{
                float: left;
                height: 13px;
                width: 13px;
                margin-top:2px;
                cursor: pointer;
            }
            .agree-txt-label{
                margin-left: 20px;
                font-size: 16px;
                line-height: 18px;
                text-align: left;
            }
            .agent-photo{
                margin: 0 auto;
                width: 152px;
                height: 152px;
                // border: none;
                background: transparent;
                &:hover{
                    // border: none;
                    box-shadow: none;
                }
            }
            .sa-frm-row{
                float: left;
                width: 100%;
                margin-bottom: 20px;
                .sa-control{
                    height: 40px;
                    font-size: 15px;
                    font-family: 'Benton Sans Book';
                    padding: 15px;
                    border-color: #211e1e;
                    .ico-control{
                        top: 10px;
                        font-size: 21px;
                    }
                }
                .sa-label.agree-txt-label{
                    font-size: 13px;
                    color: #231f20;
                }
                .error-text{
                    color: #ff0000;
                    float: left;
                    font-size: 15px !important;
                }
            }
            .ob-btn-wrapper{
                margin: 0;
            }
        }
    }
}

#panelBackdrop{
    position: fixed;
    width: 100%;
    height: 100%;
    background: #999999;
    opacity: 0.5;
    z-index: 2;
    top: 0px;
    left: 0px;
}
.popup-container{
    position: fixed;
    width: 100%;
    height: 100%;
    opacity: 1;
    z-index: 99;
    top: 0px;
    left: 0px;
    .popup-wrapper{
        margin: 45px auto;
        max-width: 100% !important;
        width: 800px;
        h1{
            font-size: 33px !important;
        }
        h4{
            font-size: 18px;
        }
        font-size: 15px;
        color: #6b6e70;
        font-family: "HelveticaNeueLTStd-Lt";
        .popup-footer{
            padding: 12px 20px;
            margin-top: 0;
            background: #fff;
            border-bottom-right-radius: 4px;
            border-bottom-left-radius: 4px;
            border-top: 1px solid #ddd;
            float: left;
            width: 100%;
            .close-button{
                color: #fff;
                background-color: #db082b;
                border-color: #a00620;
                float: right;
                font-family: "DIN MED";
                display: inline-block;
                margin-bottom: 0;
                font-weight: normal;
                text-align: center;
                vertical-align: middle;
                cursor: pointer;
                background-image: none;
                border: 0px solid transparent;
                white-space: nowrap;
                padding: 6px 0;
                font-size: 17px;
                line-height: 1.42857143;
                border-radius: 2px;
                padding: 8px 15px 4px;
                border-bottom-width: 3px;
            }
        }
        .popup-body{
            max-height: 450px;
            overflow-y: auto;
            padding: 20px;
            background: #fff;

        }
        .popup-header{
            background: #7E3E98!important;
            color: #FFF !important;
            padding: 12px 20px;
            border-top-right-radius: 4px;
            border-top-left-radius: 4px;
            span{
                font-size: 20px;
            }
            .close-icon{
                float: right;
                margin-top: 4px;
                cursor: pointer;
            }
        }
    }
}


.font-weight-600{
    font-weight: 600;
}
/* loader btn css */
.loader {
  border: 2px solid #f3f3f3; /* Light grey */
  border-top: 2px solid #7E3E98; /* Blue */
  border-radius: 50%;
  width: 20px;
  height: 20px;
  animation: spin 2s linear infinite;
  margin: 0 auto;
}
.loader-spinner{
    border: 4px solid #f3f3f3; /* Light grey */
    border-top: 4px solid #7E3E98; /* Blue */
    border-radius: 50%;
    width: 60px;
    height: 60px;
    animation: spin 2s linear infinite;
    margin: 0 auto;
    margin-top: 20vh;
}
.alert{
    height: auto;
    color: #333;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.rotate-btn-wrap{
    align-items: center;
    width: 350px;
    height: 40px;
    padding: 10px 15px;
    background-color: #7E3E98;
    border: solid 1px #595159;
    text-align: center;
    color: #fff;
    border-radius: 5px;
    float: right;
    text-align: center;
}

@font-face {
    font-family: 'HelveticaNeueLTStd';
    src: url('assets/fonts/HelveticaNeueLTStd.otf');
}
@font-face {
    font-family: 'Benton Sans Book';
    src: url('assets/fonts/Benton Sans Book.otf');
}
@font-face {
    font-family: 'HelveticaNeueLTStd-LtCn';
    src: url('assets/fonts/HelveticaNeueLTStd-LtCn.otf');
}
@font-face {
    font-family: 'HelveticaNeueLTStd-Roman';
    src: url('assets/fonts/HelveticaNeueLTStd-Roman.otf');
}
@font-face {
    font-family: 'HelveticaNeueLTStd-Cn';
    src: url('assets/fonts/HelveticaNeueLTStd-Cn.otf');
}
@font-face {
    font-family: 'HelveticaNeueLTStd-Lt';
    src: url('assets/fonts/HelveticaNeueLTStd-Lt.otf');
}
body{
    font-family: 'HelveticaNeueLTStd', sans-serif !important;
}


</style>
